var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-tooltip',{attrs:{"text":_vm._f("momentFormat")(_vm.date,'DD.MM.YYYY HH:mm')}},[_c('span',{staticClass:"messenger-date"},[_vm._v(_vm._s(_vm._f("messageDateAndTime")(_vm.date)))])])}
var staticRenderFns = []

export { render, staticRenderFns }